import Picker from '../../picker/locale/da_DK';
import DatePicker from '../../date-picker/locale/da_DK';
import DatePickerView from '../../date-picker-view/locale/da_DK';
import Menu from '../../menu/locale/da_DK';
import Calendar from '../../calendar/locale/da_DK';
import SearchBar from '../../search-bar/locale/da_DK';
import InputItem from '../../input-item/locale/da_DK';
import Pagination from '../../pagination/locale/da_DK';
import PullToRefresh from '../../pull-to-refresh/locale/da_DK';
import ActionSheet from '../../action-sheet/locale/da_DK';

export default {
  locale: 'da_DK',
  Picker,
  DatePicker,
  DatePickerView,
  Menu,
  Calendar,
  SearchBar,
  InputItem,
  Pagination,
  PullToRefresh,
  ActionSheet
};
